module.exports = __webpack_public_path__ + "img/1-1.eae1dcd5.png";